export { default as check } from './check';
export { default as close } from './close';
export { default as hint } from './hint';
export { default as chevronUp } from './chevronUp';
export { default as chevronDown } from './chevronDown';
export { default as spinner } from './spinner';
// Try to optimize the svg here https://jakearchibald.github.io/svgomg/
